// removed by extract-text-webpack-plugin
module.exports = {"ui":"navigation_ui_8etewd","logo":"navigation_logo_adyyx9","subbar":"navigation_subbar_8yec21","topbar":"navigation_topbar_5m0owz","links":"navigation_links_awe90b"};


//////////////////
// WEBPACK FOOTER
// ./packages/lib-ui/src/navigation/navigation.scss
// module id = 591
// module chunks = 0